import React from 'react'
import Tooltip from 'antd/lib/tooltip'
import { QuestionCircleOutlined } from '@ant-design/icons'

interface CapacityUseColumnTitleProps {
  title: string
}

// Shared by the modifier and variant inventory tables, which each render a
// pickup and a delivery capacity use column.
const CapacityUseColumnTitle = ({ title }: CapacityUseColumnTitleProps) => (
  <>
    <span>{title}</span>
    <Tooltip title='Hover over a value to see its source.'>
      <QuestionCircleOutlined className='_ml-8' />
    </Tooltip>
  </>
)

export default CapacityUseColumnTitle
